export default __webpack_public_path__ + "static/media/Believer's Legguards of the Purple Sun.d2938367.jpg";